<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {

}
body{
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/App.vue